import {
  InitClient,
  GetByParas,
  Post,
  PostWithParas,
  PostNoParas
} from "../ZeusAPIClient.js";
import { apiConfig } from "../../config.js";
import { PagingBody } from "../Model/PagingBody";
import { Predicate } from "../Model/Predicate";
import { EncryptContent } from "../Logic/WikiLogic";
InitClient(apiConfig.clientId, apiConfig.clientSecret, apiConfig.host);

//获取入职管理分页列表
async function GetSysUserPageList(userId, roleKey, frameId, otherFrameID, title, dataAuth, pageIndex, pageSize) {
  var data = {
    userId: userId,
    roleKey: roleKey,
    frameId: frameId,
    otherFrameID: otherFrameID,
    title: title,
    dataAuth: dataAuth,
    pageIndex: pageIndex,
    pageSize: pageSize
  };
  return await PostWithParas("be6255ed-8986-4856-aabb-f9fed3c3bbc9", '', data);
}

//获取离职管理分页列表
async function GetRemoveSysUserPageList(userId, roleKey, frameId, otherFrameID, title, dataAuth, pageIndex, pageSize) {
  var data = {
    userId: userId,
    roleKey: roleKey,
    frameId: frameId,
    otherFrameID: otherFrameID,
    title: title,
    dataAuth: dataAuth,
    pageIndex: pageIndex,
    pageSize: pageSize
  };
  return await PostWithParas("13dea776-f512-4631-a920-f7c970fbfad8", '', data);
}
//获取在职管理分页列表
async function GetOnJobSysUserPageList(userId, roleKey, frameId, otherFrameID, title, dataAuth, pageIndex, pageSize, id) {
  var data = {
    userId: userId,
    // roleKey: "admin",
    roleKey: roleKey,
    frameId: frameId,
    otherFrameID: otherFrameID,
    title: title,
    // dataAuth:'606',
    dataAuth: dataAuth,
    pageIndex: pageIndex,
    pageSize: pageSize,
    id: id
  };
  return await PostWithParas("31103bae-da8d-48c8-9d4c-a9b692c1c031", '', data);
}

//获取员工编号
async function GetUserCode() {
  return await GetByParas("d60bd325-908e-4d59-aaa6-a63fc5287c73", {});
}

//发起入职
async function InsertUserInfo(userModel) {
  var data = await PostWithParas('f3779932-6644-4ac0-bf01-95b44a844fb5', '', userModel);
  if (data.Result == 1) {
    return true;
  }
  else {
    return false;
  }
}

//通过入职员工
async function EntryUserComplete(ids, roleKey) {
  var paras = {
    ids: ids
  }
  // var data={
  //   roleKey:roleKey
  // }

  return await PostWithParas('70667006-33c5-40fe-b1ff-5bfadc560452', paras, roleKey);
  // if(data.Result==1){
  //     return true;
  // }
  // else{
  //     return false;
  // }
}

//驳回入职员工
async function SendBackMessage(ids, roleKey, note) {
  var paras = {
    id: ids,
    roleKey: roleKey
  }
  var data = await PostWithParas('6a7d6163-5245-4d89-843a-97485d9f4f3b', paras, note);
  if (data.Result == 1) {
    return true;
  }
  else {
    return false;
  }
}
//发送入职短信
async function SendEntryMessage(ids, currentUserId, currentUserName) {
  var paras = {
    ids: ids,
    currentUserId: currentUserId,
    currentUserName: currentUserName
  }
  var data = await GetByParas('5c50a7ea-d7bf-4906-9176-56aaffbf572e', paras);
  if (data.Result == 1) {
    return true;
  }
  else {
    return false;
  }
}
//删除入职信息
async function TransDeleteUser(ids) {
  // var paras={
  //   ids:ids,
  //   currentUserId:currentUserId,
  //   currentUserName:currentUserName
  // }
  var data = await PostWithParas('e4614f9e-6a24-495d-bca0-db953bc29bdf', '', ids);
  if (data.Result == 1) {
    return true;
  }
  else {
    return false;
  }
}
///导出历史轨迹excel
async function GetHistoryExportToExcel() {

  // var paras = {
  // };
  // return await GetByParas("eaea721d-ea2f-4cea-b896-f047a51c590b",paras);
  return await GetByParas("eaea721d-ea2f-4cea-b896-f047a51c590b", {});
}
///获取历史轨迹
async function GetHistoryList(id) {
  var data = {
    userid: id,
  };
  return await GetByParas("77391255-b35a-4ae0-8f93-c05f6762bad2", data);
}
///获取人员异动数据
async function GetLogList(id) {
  var data = {
    userid: id,
  };
  return await GetByParas("9d95d6a0-5b1d-4f23-ba65-6643d6ef586d", data);
}
//新增离职数据
async function RemoveUser(data) {
  //return await Post('2f7bad44-58fe-45f2-9b7b-be781e397b0a',data);
  return await PostWithParas("2f7bad44-58fe-45f2-9b7b-be781e397b0a", '', data);
}
//保存用户移动部门信息（记录）
async function UserMoveDepartmentAdd(data) {
  //return await Post('22761463-eda8-47a8-b66e-978a2c009fd5',data);
  return await PostWithParas("22761463-eda8-47a8-b66e-978a2c009fd5", '', data);
}
//调动部门
async function MoveDepartment(data) {

  return await PostWithParas("e1436c1e-9dc2-4aef-9729-6c9665c5fc02", '', data);
}

//保存用户移动部门（企业微信，邮箱）的更改信息（记录）
async function UserThirdPartyRecordAdd(data) {

  return await PostWithParas("dea9491d-b672-47ee-b7b7-33da6449ed70", '', data);
}
///移动人员的企业微信和企业邮箱组织架构
async function MoveDepentmentThirdParty(id) {
  var data = {
    userid: id,
  };
  return await GetByParas("e47b004d-14b8-4416-b001-59d11029be3c", data);
}



//检验入职人员邮箱名称
async function CheckUserName(userName) {
  var data = {
    userName: userName,
  };
  return await PostWithParas("b3fdd53e-0673-458a-90dc-11c75df696d0", '', data);
}
//检验入职人员手机号是否重复
async function CheckPhone(phone) {
  var data = {
    phone: phone,
  };
  return await GetByParas("2317d083-666d-453d-8f88-2669371b1c43", data);
}
//删除离职人员手机号
async function ClearPhone(userid, operatorid) {
  var data = {
    userid: userid,
    operatorid: operatorid
  };
  return await PostWithParas("a49139ca-02a5-449f-b371-df74097cdc8e", '', data);
}


export {
  GetSysUserPageList,
  GetUserCode,
  InsertUserInfo,
  EntryUserComplete,
  SendBackMessage,
  SendEntryMessage,
  TransDeleteUser,
  GetRemoveSysUserPageList,
  GetOnJobSysUserPageList,
  GetHistoryList,
  GetLogList,
  RemoveUser,
  GetHistoryExportToExcel,
  UserMoveDepartmentAdd,
  MoveDepartment,
  UserThirdPartyRecordAdd,
  MoveDepentmentThirdParty,
  CheckUserName,
  CheckPhone,
  ClearPhone
}
